var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plan-list-item"},[_c('v-list-tile',[_c('v-list-tile-sub-title',[_vm._t("default")],2)],1),(!_vm.end)?_c('v-divider'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }